
<template>
<div class="w-full">
  <vx-card>
    <vs-button class="w-full" @click="activePrompt = true" style="margin-bottom:10px;">객관식 문항 추가</vs-button>
    <div v-for="(multiple, index) in multipleQuestionList" :key="index">
      <div class="vx-col  w-full" Style="margin:5px;">
        <vx-card v-if="showTest">
          <div class="vx-row  items-center flex flex-wrap my-5">
            <div class="flex items-center justify-end" @click="deleteMultiple(multiple.id)">
              <vs-button class="flex items-center" color="danger" type="flat" icon="icon-trash" icon-pack="feather" />
            </div>
            <div class="flex items-center justify-end" @click="editMultiple(multiple)">
              <vs-button class="flex items-center" color="dark" type="flat" icon="icon-edit" icon-pack="feather" />
            </div>
            <span class="text-center "> {{index+1}} 번</span>
            <vs-checkbox v-model="checkboxvalList[index]" class="items-center">
              <div class="output ql-snow">
                <div class="ql-editor h-full" v-html="multiple.data"></div>
              </div>
            </vs-checkbox>
          </div>
        </vx-card>
      </div>
    </div>
  </vx-card>
  <vs-prompt class="email-compose" title="객관식 문항" accept-text="업로드" cancel-text="취소" @cancel="clearFields" @close="clearFields" @accept="createMultiple" :active.sync="activePrompt">
    <form @submit.prevent>
      <!-- <quill-editor v-model="multiple_text"></quill-editor> -->
        <quill-editor  v-model="multiple_text" :options="editorOption"></quill-editor>
    </form>
  </vs-prompt>
  <vs-prompt class="email-compose" title="객관식 수정" accept-text="업로드" cancel-text="취소" @cancel="clearFields" @close="clearFields" @accept="updateMultiple" :active.sync="activeUpdatePrompt">
    <form @submit.prevent>
      <!-- <quill-editor v-model="updateInfo.text"></quill-editor> -->
        <quill-editor v-model="updateInfo.data" :options="editorOption"></quill-editor>
    </form>
  </vs-prompt>
</div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import {
  quillEditor
} from 'vue-quill-editor'

import Quill from 'quill'
import {
  ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)


export default {
  data() {
    return {
      showTest: false,
      multiple_text: '',
      checkboxvalList: [false, false, false, false, false, false, false, false, false, false, false, false],
      activePrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      editorOption: {
        modules: {
          imageDrop: true,
          imageResize: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{
              'header': 1
            }, {
              'header': 2
            }],
            [{
              'list': 'ordered'
            }, {
              'list': 'bullet'
            }],
            [{
              'script': 'sub'
            }, {
              'script': 'super'
            }],
            [{
              'indent': '-1'
            }, {
              'indent': '+1'
            }],
            [{
              'direction': 'rtl'
            }],
            [{
              'size': ['small', false, 'large', 'huge']
            }],
            [{
              'header': [1, 2, 3, 4, 5, 6, false]
            }],
            [{
              'font': []
            }],
            [{
              'color': []
            }, {
              'background': []
            }],
            [{
              'align': []
            }],
            ['clean'],
            ['link', 'image', 'video']
          ],
        },
        theme: 'snow'
      },
      testbox: false,
      selectId: 0,
      activeUpdatePrompt: false,
      updateInfo: {
        'id': 0,
        'data': ''
      },
    }
  },
  methods: {
    deleteMultiple(id) {
      this.selectId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `클래스삭제`,
        text: '정말 삭제하시겠습니까? 클래스정보와 클래스에 포함된 프로젝트가 모두 삭제됩니다.',
        accept: this.accept
      })
    },
    editMultiple(multiple) {
      this.updateInfo = JSON.parse(JSON.stringify(multiple))
      this.activeUpdatePrompt = true
    },
    updateMultiple() {
      this.$store.dispatch('etest/updateEtestMultiple', {
          id: this.updateInfo.id,
          data: this.updateInfo.data
        })
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '수정 완료',
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    accept() {
      this.$store.dispatch('etest/deleteMultiple', this.selectId)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '삭제 완료',
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    clearFields() {
      this.$nextTick(() => {
        this.multiple_text = ''
        this.updateInfo = {
          'id': 0,
          'text': ''
        }
      })
    },
    createMultiple() {
      this.$store.dispatch('etest/createEtestMultiple', {
        'data': this.multiple_text,
        'question_id': this.activeQuestionId,
        'multiple_index': this.multipleQuestionList.length + 1
      }).then(() => {
        this.multiple_text = ''
      })
    },
  },
  watch: {
    activeQuestionId() {
      if (this.activeQuestionId) {
        this.$store.dispatch('etest/getEtestMultiple', this.activeQuestionId).then(() => {
          for (var i in this.activeQuestion.answer_multiple) {
            var index = this.multipleQuestionList.findIndex((item) => item.id == this.activeQuestion.answer_multiple[i])
            this.checkboxvalList[index] = true
          }
          this.showCode = !this.showCode
        })
      }
    },
    checkboxvalList() {
      var list = []
      for (var i = 0; i < this.checkboxvalList.length; i++) {
        if (this.checkboxvalList[i]) {
          list.push(this.multipleQuestionList[i].id)
        }
      }
      this.$store.commit('etest/SET_ANSWER_MULTIPLE', list)
    }
  },
  computed: {
    activeQuestionId() {
      return this.$store.state.etest.activeQuestion.id
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    multipleQuestionList() {
      return this.$store.state.etest.multipleQuestionList
    },
    activeQuestion() {
      return this.$store.state.etest.activeQuestion
    },
  },
  components: {
    quillEditor,
  },
  created() {
    if (this.activeQuestionId) {
      this.$store.dispatch('etest/getEtestMultiple', this.activeQuestionId).then(() => {
        for (var i in this.activeQuestion.answer_multiple) {
          var index = this.multipleQuestionList.findIndex((item) => item.id == this.activeQuestion.answer_multiple[i])
          this.checkboxvalList[index] = true
        }
        this.showTest = true
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
    text-align: center;
    width: 100%;
    display: inline-block;
    padding: 0.5em 0.75em;
    color: #000000;
    font-size: inherit;
    line-height: normal;
    vertical-align: middle;
    background-color: #E7E7E7;
    cursor: pointer;
    border: solid #E7E7E7 2px;
    border-radius: 0.25em;
    -webkit-transition: background-color 0.2s;
    transition: background-color 0.2s;
}

.filebox label:hover {
    background-color: #ffffff;
    border: solid #E7E7E7 2px;
}

.filebox label:active {
    background-color: #ffffff;
    border: solid #E7E7E7 2px;
}

.filebox input[type="file"] {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
#email-app {
    .vs-sidebar--background {
        position: absolute;
    }
    .select-all-chexkbox {
        .vs-checkbox {
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
            overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
            overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 6.3%);

        &:not(.ps) {
            overflow-y: auto;
        }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }

    .email__mails {

        .email__mail-item {
            transition: all 0.35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;

                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 3px 10px 0 #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar {
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header {
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all 0.35s;
        }

        .mail__attachment {
            .vs-chip--text {
                margin-left: 0;
                margin-right: 0;
            }
        }
    }
}
// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 730px;
        // max-height: 95vh;
        .vs-dialog-text {
            padding: 0;
            .scroll-area {
                max-height: 75vh;
                &:not(.ps) {
                    overflow-y: auto;
                }
            }
            .compose-mail-attachment {
                .con-input-upload {
                    margin: 0;
                }
            }
        }
    }
    .con-img-upload {
        .con-input-upload {
            height: 2.5rem;
            width: 100%;
        }
        .img-upload {
            // height: 4rem;
            margin: 0 1.5rem 0.5rem 0;
        }
    }
    .quill-editor {
        margin-bottom: 1.5rem;
    }
    .ql-editor {
        height: 150px;
    }
}
</style>
